import { TenantDetailsFormDataTenant } from './TenantDetailsFormDataTenant';
import { TenantDetailsFormDataMicrosoftPartner } from './TenantDetailsFormDataMicrosoftPartner';

export class TenantDetailsFormData {
    tenant: TenantDetailsFormDataTenant = new TenantDetailsFormDataTenant();
    microsoftPartner: TenantDetailsFormDataMicrosoftPartner = new TenantDetailsFormDataMicrosoftPartner();
}
